exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul li[data-v-9e728ea2] {\n  list-style: none;\n}\n.uploadDalog ul li[data-v-9e728ea2],\n.uploadDalog ul .uplFile[data-v-9e728ea2] {\n  cursor: pointer;\n  color: #0f8ee9;\n  margin: 6px;\n}\n", ""]);

// exports
